import React, { useEffect, useState, useRef } from 'react';
import { ArrowRight, Zap, Shield, TrendingUp, Clock } from 'lucide-react';
export function CTA() {
  const ctaRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ctaRef.current) {
      observer.observe(ctaRef.current);
    }
    return () => {
      if (ctaRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  return <section id="buy-now" className="py-20 md:py-32 bg-white" ref={ctaRef} data-id="element-15">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-16">
        <div className={`bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800 rounded-3xl overflow-hidden relative transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-17">
          {/* Animated background */}
          <div className="absolute inset-0 overflow-hidden" data-id="element-18">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl animate-pulse" data-id="element-19"></div>
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl animate-pulse" style={{
            animationDelay: '1s'
          }} data-id="element-20"></div>
          </div>
          <div className="relative z-10 p-12 md:p-20 text-center" data-id="element-21">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-2 mb-8" data-id="element-22">
              <Zap className="h-4 w-4 text-yellow-400" data-id="element-23" />
              <span className="text-sm text-white font-medium" data-id="element-24">
                2,000+ stores already converting more customers
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-25">
              Stop Losing Money to Cart Abandonment Today
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-26">
              Every day without CommerceBoost is revenue walking out the door. Start FREE now and watch your abandoned carts turn into completed sales.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-27">
              <a href="#pricing" className="group inline-flex items-center justify-center px-8 py-4 bg-white hover:bg-gray-100 text-gray-900 font-medium rounded-lg transition-all text-lg shadow-xl" data-id="element-28">
                Get Instant Access FREE
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-29" />
              </a>
              <a href="mailto:support@commerceboost.io" className="inline-flex items-center justify-center px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg border border-white/20 transition-all text-lg backdrop-blur-sm" data-id="element-30">
                Ask us anything
              </a>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-white/10" data-id="element-31">
              <div className="text-center" data-id="element-32">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-xl mb-3" data-id="element-33">
                  <TrendingUp className="h-6 w-6 text-green-400" data-id="element-34" />
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-35">
                  2,000+
                </h3>
                <p className="text-gray-400" data-id="element-36">Stores converting more</p>
              </div>
              <div className="text-center" data-id="element-37">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-xl mb-3" data-id="element-38">
                  <Zap className="h-6 w-6 text-yellow-400" data-id="element-39" />
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-40">
                  37%
                </h3>
                <p className="text-gray-400" data-id="element-41">Average revenue boost</p>
              </div>
              <div className="text-center" data-id="element-42">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-xl mb-3" data-id="element-43">
                  <Shield className="h-6 w-6 text-purple-400" data-id="element-44" />
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-45">
                  4.8/5
                </h3>
                <p className="text-gray-400" data-id="element-46">Stars from real users</p>
              </div>
              <div className="text-center" data-id="element-47">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-xl mb-3" data-id="element-48">
                  <Clock className="h-6 w-6 text-blue-400" data-id="element-49" />
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-50">
                  5 min
                </h3>
                <p className="text-gray-400" data-id="element-51">To see first results</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}